import React from 'react';
import {LauncherComponentBase} from '../../components/base-components/launcher-component-base';

export class PageNotFoundComponent extends LauncherComponentBase<{}> {
    render() {
        return (
            <div>This page cannot be found!</div>
        )
    }
}